import React, {useState, useEffect} from 'react'
import * as THREE from "three"
import { useTexture } from '@react-three/drei'
import { useSelector } from 'react-redux'
import { E_ColoriMetallo } from '../Utils/enumerations'
import { codiciColoreMetallo } from '../Utils/codiciColore'

// Mesh generale del paravento
export default function ParaventoGenerale({nodeCorpoName, nodeVetroName, nodeExtraName, mainRotation, pos1, rot1, sc1, pos2, rot2, sc2, pos3, rot3, sc3}) {
    const coloreMetalloParaventi = useSelector(state => state.uiMainMenu.coloreStrutture);

    const [metalColor, setMetalcolor] = useState(codiciColoreMetallo.find(el => el.colore === E_ColoriMetallo.Nero).codice);

    const plasticTexturesProps = useTexture({
      map: `${process.env.PUBLIC_URL}/textures/paraventi/Plaster_basecolor.jpg`,
      normalMap: `${process.env.PUBLIC_URL}/textures/paraventi/Plaster_normal.jpg`,
      roughnessMap: `${process.env.PUBLIC_URL}/textures/paraventi/Plaster_roughness.jpg`,
      aoMap: `${process.env.PUBLIC_URL}/textures/paraventi/Plaster_ambientOcclusion.jpg`,
    })
    
    plasticTexturesProps.map.repeat.set(0.025, 0.025);
    plasticTexturesProps.normalMap.repeat.set(0.025, 0.025);
    plasticTexturesProps.roughnessMap.repeat.set(0.025, 0.025);
    plasticTexturesProps.aoMap.repeat.set(0.025, 0.025); 
    
    plasticTexturesProps.map.wrapS = plasticTexturesProps.map.wrapT = THREE.RepeatWrapping;
    plasticTexturesProps.normalMap.wrapS = plasticTexturesProps.normalMap.wrapT = THREE.RepeatWrapping;
    plasticTexturesProps.roughnessMap.wrapS = plasticTexturesProps.roughnessMap.wrapT = THREE.RepeatWrapping;
    plasticTexturesProps.aoMap.wrapS = plasticTexturesProps.aoMap.wrapT = THREE.RepeatWrapping;  
    
    useEffect(() => {  
        if (coloreMetalloParaventi === E_ColoriMetallo.Antracite.toString())  setMetalcolor(codiciColoreMetallo.find(el => el.colore === E_ColoriMetallo.Antracite).codice);
        else if (coloreMetalloParaventi === E_ColoriMetallo.Bianco.toString()) setMetalcolor(codiciColoreMetallo.find(el => el.colore === E_ColoriMetallo.Bianco).codice);
    }, [coloreMetalloParaventi]);

    return (
        <group dispose={null} rotation={mainRotation}>
          <group position={pos1} rotation={rot1}>
            <mesh geometry={nodeCorpoName} scale={sc1} >  
              <meshStandardMaterial color={metalColor} roughness={0.25}/>        
            </mesh>
          </group>
          <group position={pos2} rotation={rot2}>
            <mesh geometry={nodeVetroName} scale={sc2}>
              <meshPhongMaterial emissive={"#ffffff"} opacity={0.3} transparent side={THREE.DoubleSide}/>         
            </mesh>
          </group>
          <group position={pos3} rotation={rot3}>
            <mesh geometry={nodeExtraName} scale={sc3}>
              <meshStandardMaterial { ...plasticTexturesProps } color={0x00cc00} />  
            </mesh>
          </group>
        </group> 
    )
}
